(() => {
  const root = document.documentElement;
  let frame = 0;
  let lastHeight = null;

  const calculateHeight = () => {
    frame = 0;
    const mobile = matchMedia('(max-width: 767px)').matches;
    let height = 0;
    const isComparing = Boolean(document.body && document.body.classList.contains('is-product-comparing'));
    const bar = document.querySelector('.compare-bar');
    if (bar && isComparing) {
      if (mobile) {
        height += !bar.classList.contains('is-show-list') ? 68 : Math.round(bar.offsetHeight || 68);
      } else {
        height += Math.round(bar.offsetHeight || 110);
      }
    }
    const atc = document.querySelector('.sticky-atc-bar--show');
    if (atc) {
      height += Math.round(atc.offsetHeight || atc.getBoundingClientRect().height);
    }
    const mobileBar = document.querySelector('.mobile-sticky-bar');
    if (mobileBar && mobile && document.body && document.body.classList.contains('mobile-sticky-bar-up')) {
      height += Math.round(mobileBar.offsetHeight || mobileBar.getBoundingClientRect().height);
    }
    if (height !== lastHeight) {
      lastHeight = height;
      root.style.setProperty('--floating-avoidance-height', `${height}px`);
    }
  };

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(calculateHeight);
  };

  const initObservers = () => {
    if (document.body) {
      new MutationObserver(schedule).observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    const stickyAtc = document.querySelector('.sticky-atc-bar, .sticky-atc-bar-minimalist');
    if (stickyAtc) {
      new MutationObserver(schedule).observe(stickyAtc, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObservers);
  } else {
    initObservers();
  }

  addEventListener('resize', schedule, { passive: true });
  addEventListener('compare-bar:visibility', schedule, { passive: true });
  addEventListener('sticky-atc:toggle', schedule, { passive: true });
  addEventListener('floating-controls:visibility', schedule, { passive: true });

  // Initial schedule deferred until idle to protect critical render path
  if ('requestIdleCallback' in window) {
    requestIdleCallback(schedule, { timeout: 2000 });
  } else {
    setTimeout(schedule, 500);
  }
})();
